var _defs, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack110({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "8 3.45 10.9 1 11.21 4.79 15 5.1 12.55 8 15 10.9 11.21 11.21 10.9 15 8 12.55 5.1 15 4.79 11.21 1 10.9 3.45 8 1 5.1 4.79 4.79 5.1 1 8 3.45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack110);
export default __webpack_public_path__ + "static/media/Symbolpack_1_10.eec6820cb98cb56056f7ee5040b9b628.svg";
export { ForwardRef as ReactComponent };